<template>
  <div>
      <modal v-show="isModalVisible" @close="closeModal" modalIsLarge footer>
        <template v-slot:title>
          <h5>View Request Details</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Request Account Name</label>
                <input
                  type="text"
                  v-model="formObj.account_name"
                  class="form-control"
                  disabled
                  placeholder="Account Name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Request Account Type</label>
                <input
                  type="text"
                  v-model="formObj.account_type"
                  class="form-control"
                  disabled
                  placeholder="Account Name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Address</label>
                <input
                  type="text"
                  v-model="formObj.address"
                  class="form-control"
                  disabled
                  placeholder="Account Name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="daily_limit">Reeason</label>
                <textarea
                  type="text"
                  v-model="formObj.details"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6" v-if="formObj.utility_file">
              <div class=" form-group">
                <a :href="formObj.utility_file" target="_blank" class="btn"
                  >View ID File</a
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class=" form-group" v-if="formObj.business_file">
                <a :href="formObj.business_file" target="_blank" class="btn"
                  >View Business File</a
                >
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-danger"
            @click="treatRequest('rejected')"
            :disabled="loading"
            v-if="formObj.status == 'pending' && permissions.includes('account-requests')"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Updating ...
              </span>
            </span>
            <span v-else>
              Reject Request
            </span>
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="treatRequest('approved')"
            :disabled="loading"
            v-if="formObj.status == 'pending' && permissions.includes('account-requests')"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Updating ...
              </span>
            </span>
            <span v-else>
              Approve Request
            </span>
          </button>
          <button @click.prevent="closeModal" class="btn btn-secondary">
            Close
          </button>
        </template>
      </modal>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>{{pageLoadingMessage}}</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h3 class=" mb-2 font-regular">Account request</h3>
        </div>
        <div class="col-auto"></div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-content">
          <div class="card-body">
            <CDataTable :items="arr" :fields="fields" sorter tableFilter>
              <template #name="{item}">
                <td class="table--action-mobile">
                  {{
                    item.user
                      ? item.user.first_name + " " + item.user.last_name
                      : "N/A"
                  }}
                </td>
              </template>
              <template #actions="{item}">
                <td class="table--action-mobile d-flex border-0">
                  <button
                    class="btn btn-secondary me-2"
                    @click="showUpdatemodal(item)"
                  >
                    View
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CPagination from "../../components/CPagination.vue";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";

const fields = ["account_type", "name", "status", "actions"];

export default {
  name: "PromosPage",
  components: {
    CDataTable,
    CPagination
  },
  computed: {
    formIsNotValid() {
      for (let key in this.formObj) {
        if (this.formObj.hasOwnProperty(key) && this.formObj[key] === "") {
          return true;
        }
      }
      return false;
    }
  },
  data() {
    return {
      fields,
      isModalVisible: false,
      pageLoadingMessage: "Getting Account Request ready...",
      pageLoading: true,
      loading: false,
      arr: [],
      formObj: {
        name: "",
        type: "",
        category: "",
        start_date: "",
        stop_date: "",
        status: ""
      },
      base_six: null,
      current: 1,
      next_page: 1
    };
  },
  methods: {
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async treatRequest(status) {
        const swalResponse = await Swal.fire({
        title: `<div>
            <p >Confirm the following Details</p>
            <p>Account Name: ${this.formObj.account_name}</p>
            <p>Account Type: ${this.formObj.account_type}</p>
            </div>`,
        text: `Are you sure you to mark this request as ${status}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      this.pageLoadingMessage = `Updating Request...`;
      this.pageLoading = true;
      try {
        const res = await ApiService.post(
          `account/treat_account_request`,
          {
            account_request_id : this.formObj.id,
            status: status
          }
        );
        this.pageLoading = false;
        this.closeModal();
        this.getAds(1);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message
        });
      } catch (error) {
        this.pageLoading = false;
        ErrorService.displayErrorAlert(error);
      }
    },

    async getAds(page) {
        this.pageLoading = true;
        this.pageLoadingMessage = `Getting Account Request ready...`;

      try {
        const res = await ApiService.get(
          `account/account_requests?page=${page}`
        );
        this.arr = res.data.data.data;
        this.current = res.data.data.current_page;
        this.total = res.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getAds(this.next_page);
      }
    },
    async showUpdatemodal(item) {
      this.formObj = Object.assign({}, item);
      this.openModal();
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onPickButton() {
      this.$refs.fileChange.click();
    },
    onFilePickedButton(event) {
      const files = event.target.files;
      let filename = files[0].name;
      this.imageFileType = files[0].type.match(/.(jpg|jpeg|png)$/i);
      if (filename.lastIndexOf(".") <= 0) {
        return alert("please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // this.service.image = fileReader.result;
        this.base_six = fileReader.result;
        // console.log(this.service.image);
        // console.log(this.service);
      });
      fileReader.readAsDataURL(files[0]);
      this.formObj.image = files[0];
    }
  },
  mounted() {
    this.getAds(1);
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
};
</script>

<style scoped></style>
